module.exports = __webpack_public_path__ + "img/C73501.ef052999.png";